export const CLOSE_FAB = 'CLOSE_FAB';

export function closeFab(item) {
  return {
    type: CLOSE_FAB,
    item,
  };
}
